import { render, staticRenderFns } from "./PriceCheck.vue?vue&type=template&id=6fd66ea4"
import script from "./PriceCheck.vue?vue&type=script&lang=js"
export * from "./PriceCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports